import { useEffect, useRef } from 'react'
import styled from 'styled-components'

import { MSG_TYPE } from 'constants/index'

import 'react-perfect-scrollbar/dist/css/styles.css'
import { ActivityItem } from './ActivityItem'
import { MessageItem } from './MessageItem'
import { memoThis } from 'utils/react'
import { useTimeoutWhen } from 'utils/hooks/useTimeoutWhen'
import { AnnouncementItem } from './AnnouncementItem'
import { AchievementItem } from './AchievementItem'

export const MessageList = memoThis(({ isOpen, messages, address }) => {
  const listRef = useRef(null)

  useEffect(() => {
    listRef?.current?.lastElementChild?.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }, [messages])

  useTimeoutWhen(
    () => {
      listRef?.current?.lastElementChild?.scrollIntoView(true)
    },
    100,
    true
  )

  return (
    <Container ref={listRef}>
      {messages.map((msg, index) => {
        switch (msg.messageType) {
          case MSG_TYPE.USER:
            return (
              <MessageItem
                key={`usr${msg.messageId || msg.timestamp}`}
                data={msg}
                isSelfMsg={msg.address === address}
                isNewMsg={index === 0 ? true : messages[index].address !== messages[index - 1].address}
              />
            )
          case MSG_TYPE.ACTIVITY:
            return <ActivityItem key={`act${msg.messageId}`} data={msg} noToast={msg.isFirstLoad} />

          case MSG_TYPE.ANNOUNCEMENT:
            return <AnnouncementItem key={`ann${msg.messageId}`} data={msg} noToast={msg.isFirstLoad} />

          case MSG_TYPE.ACHIEVEMENT:
            return <AchievementItem key={`ach${msg.messsageId}`} data={msg} noToast={msg.isFirstLoad} />

          default:
            return null
        }
      })}
    </Container>
  )
})

const Container = styled.ul``
